import { render, staticRenderFns } from "./PhoneNumbersSelector.vue?vue&type=template&id=5189d37b"
import script from "./PhoneNumbersSelector.vue?vue&type=script&lang=js"
export * from "./PhoneNumbersSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports